import isEmpty from 'lodash/isEmpty';
import { createAction, createReducer } from 'redux-act';

import { makeSeoPayload, preparePath, prepareSeoData, TListInfoFields } from '../helpers/seo';
import { IMetadata } from '../interfaces/metadata';
import { TOrganizationData } from '../interfaces/news';
import { getMetadata } from '../selectors/metadata';
import { TMetadataParams } from '../server/services/metadata';
import { loadMetadata } from '../services/metadata';
import { App } from '../types';

export type IState = {
  data: IMetadata | Record<string, any>;
};

export const setMetadata = createAction('seo/data/set', (seo: Partial<IMetadata>, pathname: string) => ({
  seo,
  pathname,
}));

export default createReducer<IState>(
  {},
  {
    data: {},
  },
).on(setMetadata, (state, payload) => {
  const { pathname, seo } = payload;

  return {
    ...state,
    data: {
      ...state.data,
      [pathname]: seo,
    },
  };
});

export const fetchSeo = (params: TMetadataParams, infoFields: TListInfoFields): App.ReduxAction => {
  return async (dispatch, getState) => {
    const pathname = params.url;
    const seo = await loadMetadata(params);

    const data = prepareSeoData(seo, getState(), infoFields);
    dispatch(setMetadata(data, pathname));
  };
};

export const fetchSeoIfNeeded = (organization: TOrganizationData, pathname: string, infoFields: TListInfoFields) => {
  return async (dispatch, getState) => {
    pathname = preparePath(pathname);

    const seo = getMetadata(pathname)(getState());

    if (isEmpty(seo)) {
      const payload = makeSeoPayload(organization, pathname, getState());
      await dispatch(fetchSeo(payload, infoFields));
    }
  };
};
